import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Timezone", -1)
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("select", {
      class: "form-control form-control-sm form-control-solid",
      value: _ctx.timezone,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.update($event.target.value)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (o) => {
        return (_openBlock(), _createElementBlock("option", {
          value: o.v
        }, _toDisplayString(o.t), 9, _hoisted_4))
      }), 256))
    ], 40, _hoisted_3)
  ]))
}